module.exports = __webpack_public_path__ + "img/chat-5.a97caeed.svg";